
import ReactLoading from 'react-loading'
import { Box, styled } from '@mui/material';
import { colors } from '../../constants/colors';

const CustomLoadingBox = styled(Box)({
    position: "fixed",
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    top: "0",
    left: "0",
    zIndex: "9999999"
})
const OverLay = styled(Box)({
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backdropFilter: "blur(8px)",
    zIndex: "-1"
})

interface Props {
    type?: 'balls' | 'bars' | 'blank' | 'bubbles' | 'cubes' | 'cylon' | 'spin' | 'spinningBubbles' | 'spokes'
}
const Loading = ({ type }: Props) => {
    const types: any = type;
    return (
        <CustomLoadingBox className={`container-fluid`}>
            <OverLay></OverLay>
            <ReactLoading type={types || "spin"} color={colors.themeMainColor} height={'10%'} width={'10%'} />
        </CustomLoadingBox>
    )
}

export default Loading
